import { formatNumber } from "@/utils/number-utils";
import { Link } from "@tanstack/react-router";
import { useMemo } from "react";
import { StatusIndicator } from "../campaign/StatusIndicator";
import { Heading } from "../generic/Heading";

export default function CreditsUsage({
  month,
  buffer,
  remaining,
  total,
}: {
  month: {
    total: number;
    remaining: number;
  };
  buffer: number;
  total: number;
  remaining: number;
}) {
  const usedPercentage = useMemo(() => {
    return total > 0 ? ((total - remaining) / total) * 100 : 0;
  }, [remaining, total]);

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between">
        <Heading level={4} className="text-base font-semibold">
          Creditforbrug
        </Heading>

        <div className="flex items-center gap-x-4">
          <div className="flex items-center gap-x-2">
            <StatusIndicator status="Theme" />
            <span className="text-theme-on-surface/70 text-sm">Brugt</span>
          </div>

          <div className="flex items-center gap-x-2">
            <StatusIndicator status="Used" />
            <span className="text-theme-on-surface/70 text-sm">Resterende</span>
          </div>
        </div>
      </div>

      <div className="my-4 h-2 w-full">
        <span className="bg-theme-primary/15 block h-2 w-full rounded-lg">
          <span
            className="from-theme-primary to-theme-secondary block h-2 rounded-lg bg-gradient-to-r"
            style={{ width: `${usedPercentage}%` }}
          />
        </span>
      </div>

      <table className="-my-2.5 border-separate border-spacing-y-2.5">
        <tbody>
          <tr className="[&>th]:text-theme-on-background-variant *:font-normal [&>td]:text-right [&>td]:text-sm [&>th]:text-left [&>th]:text-sm">
            <th>Månedligt</th>
            <td>
              {formatNumber(month.remaining)} af {formatNumber(month.total)}{" "}
              tilbage
            </td>
          </tr>

          {buffer > 0 && (
            <tr className="[&>th]:text-theme-on-background-variant *:font-normal [&>td]:text-right [&>td]:text-sm [&>th]:text-left [&>th]:text-sm">
              <th>Klippekort</th>
              <td>{formatNumber(buffer)} tilbage</td>
            </tr>
          )}
        </tbody>
      </table>

      <Link
        to="/settings/subscription/credit-usage"
        className="text-theme-active mx-auto mt-9 text-sm"
      >
        Se forbrug
      </Link>
    </div>
  );
}
